import {
  AboutCompany,
  BookingCreation,
  BookingDetailPreview,
  EquipmentSelection,
  HallSelection,
  TimeSelection,
} from "pages";
import { createBrowserRouter, Navigate } from "react-router-dom";

import ErrorBoundary from "../components/ErrorBoundary/ErrorBoundary.tsx";
import BookingById from "../pages/BookingById.tsx";

import { Routes } from "./routes";

const router = createBrowserRouter([
  {
    path: Routes.BookingCreation,
    element: (
      <ErrorBoundary>
        <BookingCreation />
      </ErrorBoundary>
    ),
    children: [
      {
        path: Routes.HallSelection,
        element: <HallSelection />,
      },
      {
        path: Routes.TimeSelection,
        element: <TimeSelection />,
      },
      {
        path: Routes.EquipmentSelection,
        element: <EquipmentSelection />,
      },
      {
        path: Routes.BookingDetailPreview,
        element: <BookingDetailPreview />,
      },
    ],
  },
  {
    path: Routes.AboutCompany,
    element: (
      <ErrorBoundary>
        <AboutCompany />
      </ErrorBoundary>
    ),
  },
  {
    path: Routes.BookingById,
    element: (
      <ErrorBoundary>
        <BookingById />
      </ErrorBoundary>
    ),
  },
  {
    path: "*",
    element: <Navigate to={Routes.BookingCreation} />,
  },
]);

export default router;
